import { render, staticRenderFns } from "./PaginationPostsGrid.vue?vue&type=template&id=29e7e31b&scoped=true&"
import script from "./PaginationPostsGrid.vue?vue&type=script&lang=js&"
export * from "./PaginationPostsGrid.vue?vue&type=script&lang=js&"
import style0 from "./PaginationPostsGrid.vue?vue&type=style&index=0&id=29e7e31b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e7e31b",
  null
  
)

export default component.exports